module.exports = __webpack_public_path__ + "submenu_award_1_active.2c13d568.png";